import axios from "axios";

const BASE_ROUTE = "case-surgery-providers";

export const getCaseSurgeryProviders = (caseId) =>
    axios.get(`${BASE_ROUTE}/${caseId}`);

export const addCaseSurgeryProvider = (payload) =>
    axios.post(BASE_ROUTE, payload);

export const removeCaseSurgeryProvider = (id) =>
    axios.delete(`${BASE_ROUTE}/${id}`);
